import { Tags } from "@/enum/tags";
import { apiSlice } from "../http";

export const pdfExtractorIcmsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadPdfExtractorIcms: builder.mutation<Blob, { body: FormData }>({
      query: ({ body }) => {
        return {
          url: `/pdf-extractor-icms/extract`,
          method: "POST",
          body,
          responseHandler: (response: Response) => response.blob(),
        };
      },
      invalidatesTags: [Tags.PDF_EXTRACTOR_ICMS],
    }),
  }),
  overrideExisting: true,
});

export const { useUploadPdfExtractorIcmsMutation } = pdfExtractorIcmsApi;
